module.exports = __webpack_public_path__ + "static/media/brush.670c5e3c.svg";